import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function Layout() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate('/login', { replace: true });
  }

  return (
    <div className="app-shell">
      <header className="app-header">
        <Link to="/difot" className="brand">
          Feramex Reporting
        </Link>
        <nav className="primary-nav">
          <NavLink to="/difot">DIFOT Dashboard</NavLink>
          <NavLink to="/invite">Invite user</NavLink>
        </nav>
        <div className="user-menu">
          <span className="user-email">{user?.email}</span>
          <button type="button" onClick={handleSignOut}>
            Sign out
          </button>
        </div>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
